const authInfo = {
  state: {
    token: '',
    ticket: '',
  },

  mutations: {
    SET_STATE: (state, nextState) => {
      Object.assign(state, nextState);
    },
  },
};

export default authInfo;
